<template>
    <footer class="index-footer">
        <div class="container">
            <div class="index-footer__sarafan-logo">Sarafan Technology</div>
            <div class="index-footer__top">
                <div class="index-footer__top-left">
                    <div class="index-footer__links">
                        <div class="index-footer__link-wrap">
                            <button type="button" class="index-footer__link"
                                    @click="$clickLink('#features', '/')">
                                Features
                            </button>
                        </div>
                        <div class="index-footer__link-wrap">
                            <router-link to="/technology" class="index-footer__link">Technology</router-link>
                        </div>
                        <div class="index-footer__link-wrap">
                            <router-link to="/privacy-policy" class="index-footer__link">Privacy Policy</router-link>
                        </div>
                        <div class="index-footer__link-wrap">
                            <router-link to="/advertisers" class="index-footer__link">Advertisers</router-link>
                        </div>
                        <div class="index-footer__link-wrap">
                            <router-link to="/about" class="index-footer__link">About</router-link>
                        </div>
                        <div class="index-footer__link-wrap">
                            <router-link to="/terms-of-use" class="index-footer__link">
                                Terms and Conditions
                            </router-link>
                        </div>
                    </div>
                </div>
                <div v-if="isRussianIP" class="index-footer__top-right">
                    <a href="https://sk.ru" target="_blank" class="index-footer__skolkovo-logo">
                        <img src="/images/skolkovo-color.svg" alt="Skolkovo logo" width="160" height="114">
                    </a>
                </div>
            </div>
            <h3 class="index-footer__subtitle">Contacts</h3>
            <div class="index-footer__bottom">
                <div class="index-footer__bottom-left">
                    <div class="index-footer__contacts">
                        <div class="index-footer__contact">
                            New York:
                            <a href="tel:+13474804426">+1 347 480 44 26</a>
                        </div>
                        <div class="index-footer__contact">
                            Saint Petersburg:
                            <a href="tel:+78124247935">+7 812 424 79 35</a>
                        </div>
                        <div class="index-footer__contact">
                            Email:
                            <a href="mailto:hi@sarafan.tech" target="_blank">hi@sarafan.tech</a>
                        </div>
                    </div>
                    <div class="index-footer__copyright">© 2020. Sarafan Technology. All rights reserved</div>
                </div>
                <div v-if="isRussianIP" class="index-footer__bottom-right">
                    <a href="https://sk.ru" target="_blank" class="index-footer__skolkovo-logo">
                        <img src="/images/skolkovo-color.svg" alt="Skolkovo logo" width="160" height="114">
                    </a>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
    import { mapState } from 'vuex'

    export default {
        computed: {
            ...mapState(['isRussianIP'])
        }
    }
</script>